import { Avatar, Divider, Flex, ScrollAreaAutosize } from "@mantine/core";
import { BoxTitle, Container } from "./StyledComponents";
import styled from "styled-components";
import { theme } from "../../theme";
import { ArrowsUpDownIcon } from "@heroicons/react/24/outline";
import SvgIcon from "../common/Icons/SvgIcon";
import { ReactComponent as Icon } from "../../assets/clockError.svg";
import { useFilterContext } from "../../context/DashboardFilterContext";
import { getLiveNotArrived } from "../../api/dashboardApi";
import { useEffect, useState } from "react";
import TimeCounter from "../common/TimeCounter";

const MissingToday = ({ flex }: { flex: any }) => {
  const { filters } = useFilterContext();
  const [employees, setEmployees] = useState<any>();
  const [sort, setSort] = useState<"asc" | "desc">("asc");

  const toggleSortDirection = () => {
    setSort((prev: any) => (prev === "asc" ? "desc" : "asc"));
  };

  const getNotArrived = async () => {
    try {
      const { data, success } = await getLiveNotArrived(filters, sort);
      if (success) {
        setEmployees(data?.employees);
      } else {
        //error
      }
    } catch (error) {}
  };

  useEffect(() => {
    getNotArrived();
  }, [filters, sort]);
  return (
    <Container $flex={flex}>
      <Flex justify={"space-between"}>
        <BoxTitle>Henüz Gelmeyenler</BoxTitle>
        <IconWrapper $direction={sort} onClick={toggleSortDirection}>
          <ArrowsUpDownIcon
            strokeWidth={2}
            color={theme.colors.brand.normal}
            height={20}
          />
        </IconWrapper>
      </Flex>
      <ScrollAreaAutosize h={"90%"}>
        <Flex direction={"column"} gap={12}>
          {employees?.map((employee: any, index: any) => (
            <>
              <Flex justify={"space-between"} gap={12}>
                <Flex gap={12}>
                  <Flex>
                    <Avatar size={40}>{employee?.name[0]}</Avatar>
                  </Flex>
                  <Flex gap={4} direction={"column"}>
                    <Text> {employee?.name} </Text>
                    <Subtext>{employee?.department}</Subtext>
                    <Subtext>{employee?.role}</Subtext>
                  </Flex>
                </Flex>
                <Flex h={"max-content"}>
                  <Badge>
                    <SvgIcon
                      color={theme.colors.alert.red}
                      Icon={Icon}
                      width={14}
                    />
                    <TimeText>
                      <TimeCounter initialTime={employee?.hoursLate} />
                    </TimeText>
                  </Badge>
                </Flex>
              </Flex>
              {index !== employees?.length - 1 && <Divider />}
            </>
          ))}
        </Flex>
      </ScrollAreaAutosize>
    </Container>
  );
};

export default MissingToday;

const Text = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.greyscale.black};
`;

const Subtext = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.colors.greyscale.gray80};
`;

const IconWrapper = styled.div<{ $direction: "asc" | "desc" }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  border-radius: 4px;
  background: #f6f5fa;
  transition: transform 0.3s ease;
  transform: ${({ $direction }) =>
    $direction === "asc" ? "rotate(0deg)" : "rotate(180deg)"};
`;

const Badge = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  padding: 4px 8px;
  background-color: #fef3f2;
  min-width: 100px;
`;

const TimeText = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  width: 50px;
  color: ${theme.colors.alert.red};
`;
